// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__16ZpL","ScreensContainer":"App_ScreensContainer__366ac","Loading":"App_Loading__24aSc"};